import m from 'mithril'
import {
    Board,
} from '@base/app/models'
import {
    Dialog,
} from '@base/app/components'

import EditComponent from '../edit'
import PhotoComponent from '../photo'

// 常數定義
const CONSTANTS = {
    SQUARE_UNIT: 900,
    AREA_THRESHOLD_LOW: 210600,
    AREA_THRESHOLD_HIGH: 270000,
}

function formatColor(photoOne, photoTwo, photoThree) {
    if(!photoOne){
        return "rgba(200,200,200,1)"
    }
    else if(photoTwo && !photoThree){
        return "#F7755E"
    }
    else if(photoTwo && photoThree){
        return "#64748B"
    }
    else{
        return ""
    }
}

/**
 * 手機版資料項目元件
 */
export default class MobileListItem {
    view(vnode) {
        const { data, index, isExpanded, money, area, showPriceInfo, cities, types, methods, onToggle, onUpdate } = vnode.attrs

        return m('.row.no-gutters.m-0.pt-2', [
            // 標題列
            m(".col-12.px-0.pt-md-1.d-flex.justify-content-start.text-left", {
                style: {
                    borderStyle: "solid",
                    borderWidth: data.is_later ? "1px" : "0px",
                    borderColor: data.is_later ? "#B80D0D" : "",
                }
            }, [
                m(`span.badge.badge-info.w-100.text-left`, {
                    style: {
                        fontSize: "1.35rem",
                        backgroundColor: formatColor(data.photo, data.phototwo, data.photothree),
                        overflow: "hidden",
                        color: data.is_later ? "#B80D0D" : "",
                        fontWeight: data.is_later ? "400" : "700"
                    },
                    onclick: (e) => {
                        e.preventDefault()
                        onToggle(index)
                    }
                }, `${index + 1}. ${data.city} - ${data.address}${data.subtitle ? `(${data.subtitle})` : ""}`)
            ]),

            // 展開的詳細內容
            isExpanded ? this.renderExpandedContent(vnode) : ""
        ])
    }

    renderExpandedContent(vnode) {
        const { data, money, area, showPriceInfo, cities, types, methods, onUpdate } = vnode.attrs

        return m(".col-12.pb-1.px-0", [
            m(".card", [
                m(".position-relative", [
                    // 照片 1
                    this.renderPhoto(data.photo, "photo"),
                    // 照片 2
                    data.phototwo ? [
                        m(".py-1"),
                        this.renderPhoto(data.phototwo, "photo")
                    ] : m(".py-2"),
                    data.photothree ? [
                        m(".py-1"),
                        this.renderPhoto(data.photothree, "photo")
                    ] : m(".py-2"),

                    // 尺寸和價格標籤
                    m(".position-absolute", {
                        style: {
                            top: "5px",
                            right: "5px",
                            fontSize: "1.5rem"
                        }
                    }, [
                        m("span.badge.badge-warning.px-2", { style: { backgroundColor: "#FFEFA6" } }, `${data.height} * ${data.width}`),
                        m(".px-1"),
                        m("span.badge.badge-warning.px-2", { style: { backgroundColor: "#FFEFA6" } }, `${Math.ceil(area / CONSTANTS.SQUARE_UNIT)} 才`),

                        showPriceInfo ? [
                            m(".px-1"),
                            area >= CONSTANTS.AREA_THRESHOLD_HIGH ?
                                m("span.badge.badge-danger.px-2", { style: { backgroundColor: "#E98873" } }, "足才") :
                                m("span.badge.badge-danger.px-2", { style: { backgroundColor: "#E98873" } }, "不足才"),
                            (area >= CONSTANTS.AREA_THRESHOLD_LOW && area < CONSTANTS.AREA_THRESHOLD_HIGH) ?
                                m("span.badge.badge-danger.px-2.d-block", { style: { backgroundColor: "#E98873" } }, "以300才計算") : "",
                            m("span.badge.badge-danger.px-2.d-block", { style: { backgroundColor: "#6DE0E5" } }, `$ ${money}`)
                        ] : ""
                    ])
                ]),

                // 資料內容
                m(".card-body.pb-2.px-2.pt-2.position-relative", {
                    style: { fontSize: "1rem" }
                }, [
                    m("span.d-block", `方式：${data.method}`),
                    m("span.d-block", `聯絡：${data.contact}`),
                    m("span.d-block", `電話：${data.phone || ""}`),
                    m("span.d-block", `吊車：${data.is_car ? "是" : "否"}`),
                    m("span.d-block", `廠商：${data.company}`),
                    m("span.d-block", `鷹架：${data.is_eagle ? "是" : "否"}`),
                    m("span.d-block", `租金：${data.rent}`),
                    data.is_paid_one ? m("span.d-block", "第一次付款：是") : "",
                    data.is_paid_two ? m("span.d-block", "第二次付款：是") : "",
                    m("span.d-block", `備註：${data.memo || ""}`),
                    m("span.d-block", `版面內容：${data.title || ""}`),

                    // 操作按鈕
                    this.renderActionButtons(vnode)
                ])
            ])
        ])
    }

    renderPhoto(photo, type) {
        if (!photo) return m(".py-2")

        return m("img.img-fluid", {
            src: `${window.BASE_URL}/images/boards/${photo}`,
            style: { maxHeight: "160px" },
            onclick: (e) => {
                e.preventDefault()
                Dialog.show(PhotoComponent, {
                    attrs: { photo, type },
                    didHide: () => {}
                })
            }
        })
    }

    renderActionButtons(vnode) {
        const { data, cities, types, methods, onUpdate } = vnode.attrs

        return m(".d-flex.justify-content-end", [
            // 正/延 按鈕
            m("button.btn.btn-danger.btn-sm.mx-0.mx-md-1.my-1.my-md-0[type='button'].border-0", {
                style: {
                    background: data.is_later ? "#C7D9A4" : "#E6AAAA",
                    color: "#FFF",
                    height: "45px",
                    width: "45px"
                },
                onclick: (e) => {
                    e.preventDefault()
                    data.is_later = !data.is_later
                    m.redraw()
                    Board.changeStatus(data.id)
                }
            }, data.is_later ? m("span", "正") : m("span", "延")),

            m(".px-2"),

            // Google Maps 連結
            m("img.img-fluid", {
                src: `${window.BASE_URL}/img/google.png`,
                style: { maxHeight: "55px", maxWidth: "55px" },
                onclick: (e) => {
                    e.preventDefault()
                    const url = data.type === "地址"
                        ? `https://www.google.com/maps/search/${data.city}${data.address}`
                        : `https://www.google.com/maps/search/${data.city}${data.address.replace('與', ' ')}`
                    window.open(url)
                }
            }),

            m(".px-2"),

            // 編輯按鈕
            m("button.btn.btn-primary.btn-sm.mx-0.mx-md-1.my-1.my-md-0[type='button'].border-0", {
                style: {
                    background: "#316A38",
                    color: "#FFF",
                    height: "45px",
                    width: "45px"
                },
                onclick: (e) => {
                    e.preventDefault()
                    Dialog.show(EditComponent, {
                        attrs: {
                            model: new Board(data),
                            cities,
                            types,
                            methods
                        },
                        didHide: (returnValue) => {
                            if (returnValue) onUpdate()
                        }
                    })
                }
            }, m("i.fa.fa-edit")),

            m(".px-2"),

            // 刪除按鈕
            m("button.btn.btn-danger.btn-sm.mx-0.mx-md-1.my-1.my-md-0[type='button'].border-0", {
                style: {
                    background: "#DC3545",
                    color: "#FFF",
                    height: "45px",
                    width: "45px"
                },
                onclick: (e) => {
                    e.preventDefault()
                    if (confirm("確定要刪除此項目嗎？")) {
                        Board.delete(data.id).then(() => {
                            onUpdate()
                        })
                    }
                }
            }, m("i.fa.fa-trash"))
        ])
    }
}
